import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ spacing }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: spacing(3),
    padding: spacing(0, 3)
  },
  typographyWrapper: {
    display: "flex",
    alignItems: "center",
    gap: spacing(2)
  },
  tooltipIcon: {
    color: blueGrey[500]
  }
}))
